<template>
    <div class="col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-3 text-center mb-4">
    <!--<div class="col-xs-6 col-md-4 col-lg-3 col-xl-2 text-center mb-3">-->
        <div class="card facebook">
            <!--Card image-->
            <div class="view overlay">
                <img :src="feed.thumb" class="img-fluid" alt="sample" style="min-width:100%">
                <a :href="feed.link" target="_blank">
                    <div class="mask rgba-white-slight"></div>
                </a>
            </div>
            <!--/.Card image-->
            <!--Button-->
            <a class="btn-floating btn-action ml-auto mr-4 lighten-3" 
                style="background:#0188c0;"
                :href="feed.link" target="_blank">
                <i class="fa fa-chevron-right"></i></a>
            <!--Card content-->
            <div class="card-body">
                <!--Title
                <h4 class="card-title">Card title</h4>
                <hr>-->
                <!--Text-->
                <p class="font-small grey-dark-text mb-0 text-left" v-html="linkifiedContent"></p>
            </div>
            <!--/.Card content-->
            <!-- Card footer -->
            <div class="lighten-3 text-center" style="background:#0188c0;">
                <ul class="list-unstyled list-inline font-small mt-3">
                    <li class="list-inline-item pr-2 white-text"><i class="fa fa-clock-o pr-1"></i>{{formatDate()}}</li>
                </ul>
            </div>
            <!-- Card footer -->
        </div>
    </div>

</template>

<script>
import moment from 'moment';
export default {
    props: {
        'feed': {
            type: Object
        }
    },
    data () {
        return {

        }
    },
    computed: {
        linkifiedContent() {
            var linkified = this.linkify(this.feed.content.replace(/<(?:.|\n)*?>/gm, ' '));
            //if (linkified.length < 260) {
                return linkified;
            //} else {
            //    return linkified.substr(0,260) + "...";
            //}
            
        }
    },
    methods: {
        linkify(inputText) {
            //https://stackoverflow.com/questions/37684/how-to-replace-plain-urls-with-links
            //URLs starting with http://, https://, or ftp://
            var replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
            var replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

            //URLs starting with www. (without // before it, or it'd re-link the ones done above)
            var replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
            replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

            //Change email addresses to mailto:: links
            var replacePattern3 = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
            replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

            return replacedText;
        },
        formatDate() {
            if (this.feed.publishedDate) {
                return moment(String(this.feed.publishedDate)).format('DD.MM.YYYY hh:mm')
            } else {
                return "";
            }
        }
    }
}
</script>

<style>
    .card.facebook {
        margin-left:10%!important;
        margin-right:10%!important;
    }
    @media (min-width: 568px) {
        .card.facebook {
            margin-left:5%!important;
            margin-right:5%!important;
        }
    }
    @media (min-width: 768px) {
        .card.facebook {
            margin-left:0%!important;
            margin-right:0%!important;
        }
    }
    @media (min-width: 1200px) {
        .card.facebook {
            margin-left:10%!important;
            margin-right:10%!important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Facebook.vue